import PropTypes from 'prop-types';
import React, {useState} from 'react';
import {Mutation} from 'react-apollo';
import {Col, Container, Row} from 'react-bootstrap';
import {withTranslation} from 'react-i18next';
import {BeatLoader} from 'react-spinners';
import styled from 'styled-components';
import {dateFormatFR} from '../../../utils';
import Error from '../../../common/components/Error/Error';
import MandatoryInput from '../../../common/components/layout/MandatoryInput';
import {CancelButton, FooterRow, GradientCol, Input, TitleButton} from '../../../common/components/StyledComp';
import Tooltip from '../../../common/components/Tooltip';
import {GRAPHQL_MUTATION_UPDATE_USER_OR_ADMIN} from '../../../common/queries/users';
import '../assets/style.scss';

const AttributeDiv = styled.div`
  text-transform: uppercase;
  font-family: 'Segoe UI Bold', sans-serif;
  font-size: 12px;
  margin-left: 15px;
`;

const MarginInput = styled(Input)`
  margin-left: 15px;
`;

const MarginTooltip = styled.div`
  margin-left: 15px;
`;
const AdminDetails = ({t, admin, setDetailsVisible}) => {
  const {id, firstName, lastName, email, createdAt, mobilePhone} = admin;

  const [submitted, setSubmitted] = useState(false);
  const [newUser, setNewUser] = useState({id, firstName, lastName, email, mobilePhone});
  const [existingEmail, setExistingEmail] = useState(false);
  const [updateError, setError] = useState(null);

  const updateUser = updateUserInfo => {
    setSubmitted(true);
    if (newUser.lastName !== '' && newUser.firstName !== '' && newUser.email !== '') {
      updateUserInfo({variables: {userInput: newUser}})
        .then(res => {
          if (res.data.updateUserOrAdmin.error) {
            setExistingEmail(true);
          } else {
            setDetailsVisible(false);
          }
        })
        .catch(err => {
          setError(err);
        });
    }
  };

  return (
    <Mutation mutation={GRAPHQL_MUTATION_UPDATE_USER_OR_ADMIN} refetchQueries={['users', 'admins']}>
      {(updateUserInfo, {error, loading}) => {
        if (error) {
          setError(error);
        }
        return (
          <>
            <Container>
              <Row className="info-row">
                <Col xs={6}>
                  <MandatoryInput
                    title={`${t('dataTable.lastname')} : `}
                    name="lastName"
                    value={newUser.lastName}
                    onChange={(name, value) => setNewUser({...newUser, lastName: value})}
                    show={newUser.lastName === '' && submitted}
                  />
                  <MandatoryInput
                    title={`${t('dataTable.firstname')} : `}
                    name="firstName"
                    value={newUser.firstName}
                    onChange={(name, value) => {
                      setNewUser({...newUser, firstName: value});
                    }}
                    show={newUser.firstName === '' && submitted}
                  />
                  <MandatoryInput
                    title={`${t('dataTable.email')} : `}
                    name="email"
                    value={newUser.email}
                    onChange={(name, value) => setNewUser({...newUser, email: value})}
                    show={newUser.email === '' && submitted}
                  />
                  <MarginTooltip>
                    <Tooltip show={existingEmail} color="red">
                      {t('addUser.existingEmail')}
                    </Tooltip>
                  </MarginTooltip>
                </Col>
                <Col xs={6}>
                  <Col xs={12}>
                    <label>
                      <AttributeDiv>{t('dataTable.phoneNumber')}</AttributeDiv>
                      <MarginInput
                        value={newUser.mobilePhone === null ? '' : newUser.mobilePhone}
                        onChange={e => setNewUser({...newUser, mobilePhone: e.target.value === '' ? null : e.target.value})}
                      />
                    </label>
                  </Col>
                  <Col xs={12}>
                    <label>
                      <AttributeDiv>{t('dataTable.creation')}</AttributeDiv>
                      <MarginInput disabled value={dateFormatFR({date: createdAt})} />
                    </label>
                  </Col>
                </Col>
              </Row>
              <FooterRow>
                <GradientCol sm={{span: 6, offset: 3}}>
                  {updateError && <Error error={error}/>}
                  <div className="popin-buttons">
                    <div>
                      {
                        loading ? <BeatLoader loading={loading}/> : (
                          <TitleButton disabled={loading} onClick={() => updateUser(updateUserInfo)}>
                            {t('addUser.save')}
                          </TitleButton>
                        )
                      }
                    </div>
                    <CancelButton
                      onClick={() => setDetailsVisible(false)} style={{marginTop: 0, width: 'auto'}}>
                      {t('addUser.cancel')}
                    </CancelButton>
                  </div>
                </GradientCol>
              </FooterRow>
            </Container>
          </>
        );
      }}
    </Mutation>
  );
};

AdminDetails.propTypes = {
  t: PropTypes.func.isRequired,
  admin: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    firstName: PropTypes.string.isRequired,
    lastName: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    isActive: PropTypes.bool.isRequired,
    mobilePhone: PropTypes.string,
    createdAt: PropTypes.string.isRequired,
  }).isRequired,
  setDetailsVisible: PropTypes.func.isRequired,
};

export default withTranslation('admin')(AdminDetails);
